import type {ContactMessage} from '@cp/model';
import {useCallback} from 'react';
import type {FirestorePaginationCursor} from '../helper/useFirestorePagination';
import {useFirestorePagination} from '../helper/useFirestorePagination';
import listContactMessageDoc from '../../api/contactMessage/listContactMessageDoc';

export const CONTACT_MESSAGE_LIST_LIMIT = 10;

export interface UseListContactMessageOptions {
  limit?: number;
  includeArchived?: boolean;
  includeRead?: boolean;
  includeUnread?: boolean;
}

export function useListContactMessage(options: UseListContactMessageOptions = {}) {
  const limit = options.limit ?? CONTACT_MESSAGE_LIST_LIMIT;
  const includeArchived = options.includeArchived ?? false;
  const includeRead = options.includeRead ?? true;
  const includeUnread = options.includeUnread ?? true;
  const buildQuery = useCallback(
    (cursor: FirestorePaginationCursor<ContactMessage>) => {
      return listContactMessageDoc({limit, includeArchived, includeRead, includeUnread}, cursor);
    },
    [limit, includeArchived, includeRead, includeUnread],
  );

  const result = useFirestorePagination<ContactMessage>({buildQuery, limit});

  return {
    messages: result.data,
    handleNextPage: result.handleNextPage,
    handlePrevPage: result.handlePrevPage,
    handleFirstPage: result.handleFirstPage,
    canGoNext: result.canGoNext,
    canGoPrev: result.canGoPrev,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}
